import React from 'react';
import type { CostsViewMode } from '../../../../types/costs';

const tabBase =
    'px-3 py-2 rounded-xl text-sm border transition-all focus:outline-none focus:ring-0 focus:ring-offset-0';

const ViewModeTabs = ({
    value,
    onChange,
}: {
    value: CostsViewMode;
    onChange: (v: CostsViewMode) => void;
}) => {
    const items: { label: string; value: CostsViewMode }[] = [
        { label: 'All', value: 'mix' },
        { label: 'Stats', value: 'stats' },
        { label: 'Table', value: 'table' },
    ];

    return (
        <div className='flex items-center gap-2'>
            {items.map((it) => {
                const active = it.value === value;
                return (
                    <button
                        key={it.value}
                        type='button'
                        onClick={() => onChange(it.value)}
                        className={`${tabBase} ${active
                                ? 'bg-[#00330f] text-white border-[#00330f] dark:bg-white dark:text-black dark:border-white'
                                : 'bg-white text-black border-gray-200 dark:bg-black dark:text-white dark:border-borderColor-darkMode hover:opacity-90'
                            }`}
                    >
                        {it.label}
                    </button>
                );
            })}
        </div>
    );
};

export default ViewModeTabs;